module.exports = __webpack_public_path__ + "static/media/29.2457e8f4.wav";